import { Component, ViewChild } from "@angular/core";
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
} from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { User } from "src/app/core/models/user.model";
import { AlertService } from "src/app/core/services/alert.service";

import { lastValueFrom, take } from "rxjs";

@Component({
  selector: "app-user-detail-modal",
  templateUrl: "./user-detail-modal.component.html",
  styleUrls: ["./user-detail-modal.component.css"],
})
export class UserDetailModalComponent {
  @ViewChild("modalReason", { static: false })
  modalReason?: ModalDirective;
  withdrawalData: any;
  public bsModalRef?: BsModalRef;
  userId: any;
  userData: User;
  user: User;
  constructor(
    public modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) {}
  getUpperLevelName(user: User): string {
    switch (user.upper_level_name) {
      case "apartment":
        return "아파트";
      case "officetel":
        return "오피스텔";
      case "shop":
        return "상가";
      case "other":
        return "정보없음";
      default:
        return user.upper_level_name || "정보없음";
    }
  }
  async ngOnInit(): Promise<void> {
    console.log("this.userData =", this.user);
    await this.getData();

    if (!this.user) {
      this.user = this.userData;
    }
  }

  async getData() {
    try {
      this.spinner.show();

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      this.alertService.errormsg("데이터를 불러오는 도중 문제가 생겼습니다.");
    }
  }

  isPastDate(dateString: string): boolean {
    const currentDate = new Date(); // 현재 날짜
    const inputDate = new Date(dateString); // dateString을 Date 객체로 변환
    // 입력된 날짜가 현재보다 과거인지 체크
    return inputDate < currentDate;
  }

  // 상태 텍스트 변환
  getStatusText(status: string): string {
    switch (status) {
      case "active":
        return "활동회원";
      case "suspended":
        return "정지회원";
      case "withdraw":
        return "탈퇴회원";
      default:
        return status || "미정";
    }
  }

  // 상태 클래스 반환
  getStatusClass(status: string): string {
    switch (status) {
      case "active":
        return "badge bg-success";
      case "suspended":
        return "badge bg-warning";
      case "withdraw":
        return "badge bg-danger";
      default:
        return "badge bg-secondary";
    }
  }

  removeUser(householdUserIds: User[]): User[] {
    return householdUserIds.filter((user) => user.id !== this.userId);
  }

  // 입주구분 텍스트 변환
  getLevelText(level: string): string {
    const levelMap = {
      apartment: "아파트",
      office: "오피스텔",
      shop: "상가",
      other: "정보없음",
    };
    return levelMap[level] || level || "정보없음";
  }

  // 거주타입 텍스트 변환
  getResidenceTypeText(residenceType: string): string {
    const residenceMap = {
      apartment: "아파트",
      office: "오피스텔",
      shop: "상가",
      villa: "빌라",
      townhouse: "타운하우스",
      condo: "콘도",
      other: "기타",
    };
    return residenceMap[residenceType] || residenceType || "정보없음";
  }

  // 세대주 구분 텍스트 변환 (3가지 조건)
  getHouseholdStatusText(user: User): string {
    if (!user.headofhouseholdId) {
      return "미신청";
    }
    return user.isHeadofhousehold ? "세대주" : "세대원";
  }

  // 세대주 구분 클래스 반환 (3가지 조건)
  getHouseholdStatusClass(user: User): string {
    if (!user.headofhouseholdId) {
      return "badge bg-secondary"; // 미신청: 회색
    }
    return user.isHeadofhousehold ? "badge bg-primary" : "badge bg-info"; // 세대주: 파란색, 세대원: 하늘색
  }

  // 세대주 구분 아이콘 반환 (3가지 조건)
  getHouseholdStatusIcon(user: User): string {
    if (!user.headofhouseholdId) {
      return "mdi mdi-account-off"; // 미신청: 비활성화 아이콘
    }
    return user.isHeadofhousehold
      ? "mdi mdi-account-star"
      : "mdi mdi-account-group"; // 세대주: 별 아이콘, 세대원: 그룹 아이콘
  }
}
